var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-book-additional-hours p-4" }, [
    _c("div", { staticClass: "row mb-3" }, [
      _c(
        "div",
        { staticClass: "col-12 col-md-8 offset-md-2" },
        [
          _c(
            "router-link",
            {
              staticClass: "text-primary-link",
              attrs: {
                to: _vm.isLineLoggedIn
                  ? "/line-liff/bookings"
                  : "/my-reservations"
              }
            },
            [_vm._v(_vm._s(_vm.$t("message.menu.my_reservations")))]
          ),
          _vm._v(" "),
          _c("i", { staticClass: "fal fa-angle-right" }),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "text-primary-link",
              attrs: { to: "/reservation/" + _vm.order.id }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("message.my_reservations.reservation_detail")) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c("i", { staticClass: "fal fa-angle-right" }),
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("message.my_reservations.additional_hours")) +
              "\n    "
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row pt-4" }, [
      _c(
        "div",
        { staticClass: "col-12 col-lg-6 offset-lg-3" },
        [
          _c("div", { staticClass: "row d-flex align-items-center" }, [
            _c("div", { staticClass: "col-4 p-0" }, [
              _c("label", { staticClass: "mb-0" }, [
                _vm._v(
                  _vm._s(_vm.$t("message.my_reservations.additional_hours")) +
                    ":"
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-8 p-0" }, [
              _vm.parentServiceId
                ? _c("div", { staticClass: "select-jumbo" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedData,
                            expression: "selectedData"
                          }
                        ],
                        on: {
                          change: [
                            function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.selectedData = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                            _vm.reCalculateCost
                          ]
                        }
                      },
                      _vm._l(_vm.durations, function(duration) {
                        return _c("option", { domProps: { value: duration } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(duration.text) +
                              "\n              "
                          )
                        ])
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.subtotal
            ? _c("div", [
                _c("hr"),
                _vm._v(" "),
                _c("div", { staticClass: "row text-secondary" }, [
                  _c("div", { staticClass: "col-6 p-0" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t(
                            "message.my_reservations.summary_total.subtotal"
                          )
                        ) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 p-0 text-right" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("currency")(_vm.subtotal)) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-1 text-secondary" }, [
                  _c("div", { staticClass: "col-6 p-0" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t(
                            "message.my_reservations.summary_total.service_vat"
                          )
                        ) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 p-0 text-right" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.subtotal * _vm.globalState.serviceVat
                          )
                        ) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-3" }, [
                  _c("div", { staticClass: "col-6 p-0" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.my_reservations.summary_total.total")
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-6 p-0 text-right" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm._f("currency")(_vm.totalPrice)))
                    ])
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("payment-methods", {
            ref: "paymentMethods",
            on: {
              onSelectedPaymentMethod: _vm.updatePaymentMethod,
              onSelectedCreditCard: _vm.applyUserCreditCard,
              onRequestedSavingTempData: _vm.saveTempData,
              onSelectedFileUpload: _vm.setFileUpload,
              onRequestedUpdatingQrResponse: _vm.updateQrResponse,
              onSuccessQrPayment: _vm.displaySuccessDialog
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "pt-2" }, [
            _vm.paymentMethod !== "promptpay"
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-info btn-block",
                    attrs: { disabled: _vm.isLoading },
                    on: {
                      click: function($event) {
                        return _vm.saveAdditionalHours()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.isLoading
                            ? _vm.$t("message.button.loading")
                            : _vm.$t("message.button.submit_booking")
                        ) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.isLineLoggedIn
      ? _c(
          "div",
          { staticClass: "container text-center pt-3 pb-4" },
          [
            _c(
              "router-link",
              { attrs: { to: "/reservation/" + _vm.order.id } },
              [
                _c("i", { staticClass: "fas fa-angle-left" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("message.booking.new_booking.back")) +
                    "\n    "
                )
              ]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d198484", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d198484","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/BookAdditionalHours.vue
// module id = 1789
// module chunks = 0